<template>
    <DataTable
        :header="$t('listOfProposedProducts')"
        :fields="fields"
        :items="parentComponent.items"
        :loading="parentComponent.loading"
        :error="parentComponent.error"
        :total-rows="parentComponent.requestData.max"
        :current-page.sync="parentComponent.tableParams.page"
        :per-page.sync="parentComponent.tableParams.perPage"
        :sort-by.sync="parentComponent.tableParams.sort"
        :sort-direction.sync="parentComponent.tableParams.order"
        no-sort-reset
        no-local-sorting
    >
        <template #cell(action)="{item}">
            <ButtonIcon size="sm" :to="getItemUrl(item)">
                {{ $t('show') }}
            </ButtonIcon>
        </template>
    </DataTable>
</template>



<script>
    import DataTable from '@/components/common/DataTable.vue';

    export default {
        name: 'Results',
        components: {
            DataTable,
        },
        inject: {
            parentComponent: {
                default: null,
            },
        },
        data() {
            return {};
        },
        computed: {
            fields() {
                return [
                    { key: 'id', label: this.$t('id') },
                    { key: 'importedVariant.name', label: this.$t('name') },
                    { key: 'importedVariant.author', label: this.$t('author') },
                    { key: 'status', label: this.$t('status'), formatter: value => this.$tx(`catalogIssueStatuses.${value}`, value) },
                    { key: 'createdAt', label: this.$t('createdAt'), formatter: value => this.$format.date(value) },
                    { key: 'type', label: this.$t('automaticErrorCode') },
                    { key: 'action', label: '' },
                ];
            },
        },
        methods: {
            getItemUrl(item) {
                return {
                    name: 'ImportModerationDetails',
                    params: { id: item.id, parentUrl: this.$route.params.parentUrl || this.$route.fullPath },
                    query: {},
                };
            },
        },
    };
</script>
